import { FOLLOW_PROCESSING_START } from 'root/src/client/logic/creatorData/actionIds'

export default () => ({
	type: FOLLOW_PROCESSING_START,
})
